import React from 'react';
import {
    Box,
    Typography,
    Tooltip,
    IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CommentIcon from '@mui/icons-material/Comment';
import NeckSizeGraph from './profileModel-DialogBox/Ghraph';

const MeasurementSection = ({
    title,
    currentValue,
    onClickHandler,
    type,
    userComment,
    onAddClick,
    unit,measurements,
}) => {
    return (
        <Box display="flex" flexDirection="row" alignItems="center" sx={{ marginLeft: 2 }}>
            <Box flex="1">
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 300, cursor: 'pointer', fontSize: '18px' }}
                    onClick={onClickHandler}
                >
                    {title}
                </Typography>
            </Box>
            
            <Box flex="1" width="100%">
                    <NeckSizeGraph type={type} showLine={false} measurements={measurements} 
                     height="200px" 
                     //width="100%"
                     />
            </Box>
            <Box flex="1" display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                <Typography
                    variant="h5"
                    sx={{ fontWeight: 300, fontSize: '24px' }}
                >
                    {currentValue}
                    {currentValue && (
                        <span style={{ fontSize: '14px', color: '#757575' }}> {unit}</span>
                    )}
                </Typography>
                {userComment && (
                    <Tooltip title={userComment}>
                        <CommentIcon className="cursor-pointer" />
                    </Tooltip>
                )}
                <IconButton
                    size="small"
                    onClick={() => onAddClick(type,unit)}
                >
                    <AddIcon color="secondary" />
                </IconButton>
            </Box>
        </Box>
    );
};

export default MeasurementSection;
